import { Spin } from "antd";
import { useEffect, useState } from "react";
import {
  DOWNLOAD_STATUS,
  useGlobalDownloader,
} from '../../../../context/global/DownloadProvider';
import "./style.scss";

const PdfPreview = ({ pdfPreviewResourceId }) => {
  const [loading, setLoading] = useState(true);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  const { downloads, startDownload } = useGlobalDownloader();

  useEffect(() => {
    startDownload(pdfPreviewResourceId, "pdf-preview", 0, false);
  }, [pdfPreviewResourceId]);

  useEffect(() => {
    if (downloads[pdfPreviewResourceId]?.status === DOWNLOAD_STATUS.SUCCESS) {
      const finalBlob = new Blob(downloads[pdfPreviewResourceId]?.partialBlob, {
        type: downloads[pdfPreviewResourceId]?.partialBlob[0]?.type,
      });

      URL.revokeObjectURL(downloads[pdfPreviewResourceId].fileUrl);
      const fileUrl = URL.createObjectURL(finalBlob);
      setPdfBlobUrl(fileUrl);
      setLoading(false);
    }
  }, [downloads[pdfPreviewResourceId]]);

  return (
    <div className="pdf-preview-container">
      {loading ? (
        <div className="pdf-message">
          <Spin tip="Loading..." size="large" />
        </div>
      ) : error ? (
        <div className="pdf-message">
          Unable to display document (May be in the process of conversion).
        </div>
      ) : (
        pdfBlobUrl && (
          <iframe
            title="PDF Preview"
            src={`${pdfBlobUrl}#toolbar=1&navpanes=0&scrollbar=1`}
            className="pdf-iframe"
          />
        )
      )}
    </div>
  );
};

export default PdfPreview;

